import { useEffect, useRef, useState } from "react";

declare global {
  namespace JSX {
    interface IntrinsicElements {
      "vturb-smartplayer": React.DetailedHTMLProps<
        React.HTMLAttributes<HTMLElement> & { id?: string },
        HTMLElement
      >;
    }
  }
}

const PLAYER_ID = "vid-69f4fd41e39d77dba3409559";
const PLAYER_SRC =
  "https://scripts.converteai.net/91de7f15-bf35-4102-b055-4a4927e7a9e9/players/69f4fd41e39d77dba3409559/v4/player.js";

const VTurbPlayer = () => {
  const ref = useRef<HTMLDivElement>(null);
  const [load, setLoad] = useState(false);

  useEffect(() => {
    if (!ref.current || load) return;
    const io = new IntersectionObserver(
      (entries) => {
        if (entries.some((e) => e.isIntersecting)) {
          setLoad(true);
          io.disconnect();
        }
      },
      { rootMargin: "200px" },
    );
    io.observe(ref.current);
    return () => io.disconnect();
  }, [load]);

  useEffect(() => {
    if (!load) return;
    if (document.querySelector(`script[src="${PLAYER_SRC}"]`)) return;
    const s = document.createElement("script");
    s.src = PLAYER_SRC;
    s.async = true;
    document.head.appendChild(s);
  }, [load]);

  return (
    <div ref={ref} style={{ minHeight: 220 }}>
      {load && (
        <vturb-smartplayer
          id={PLAYER_ID}
          style={{ display: "block", margin: "0 auto", width: "100%", maxWidth: "400px" }}
        />
      )}
    </div>
  );
};

export default VTurbPlayer;